import { render, staticRenderFns } from "./GroupHome.vue?vue&type=template&id=0e861257"
import script from "./GroupHome.vue?vue&type=script&lang=js"
export * from "./GroupHome.vue?vue&type=script&lang=js"
import style0 from "./GroupHome.vue?vue&type=style&index=0&id=0e861257&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports